import type { ExploreBriefCard } from "../types";

export interface BriefGroup {
  categorySlug: string;
  categoryDisplayName: string;
  categoryEmoji: string;
  categoryDisplayOrder: number;
  briefs: ExploreBriefCard[];
}

export function groupBriefsByCategory({
  briefs,
  activeCategory,
}: {
  briefs: ExploreBriefCard[];
  /** When viewing a specific category page, skip sub-grouping and return a flat list. */
  activeCategory?: {
    slug: string;
    displayName: string;
    emoji: string;
  };
}): BriefGroup[] {
  // On a category page, all briefs already belong to that category
  // (filtered upstream). Show them flat — no sub-grouping needed.
  if (activeCategory && briefs.length > 0) {
    return [
      {
        categorySlug: activeCategory.slug,
        categoryDisplayName: activeCategory.displayName,
        categoryEmoji: activeCategory.emoji,
        categoryDisplayOrder: 0,
        briefs,
      },
    ];
  }

  const groupMap = new Map<string, BriefGroup>();

  for (const brief of briefs) {
    const slug = brief.categorySlug ?? "uncategorized";
    const existing = groupMap.get(slug);
    if (existing) {
      existing.briefs.push(brief);
    } else {
      groupMap.set(slug, {
        categorySlug: slug,
        categoryDisplayName: brief.categoryDisplayName ?? "Other",
        categoryEmoji: brief.categoryEmoji ?? "📌",
        categoryDisplayOrder: brief.categoryDisplayOrder,
        briefs: [brief],
      });
    }
  }

  return [...groupMap.values()].sort(
    (a, b) => a.categoryDisplayOrder - b.categoryDisplayOrder
  );
}

export const MAX_VISIBLE_BRIEFS = 3;
